import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit
} from '@angular/core';
import { InsightsSectionComponent } from '../../../details-page/components/insights-section/insights-section.component';

@Component({
  selector: 'app-mfa-section',
  templateUrl: './app-mfa-section.component.html',
  styleUrls: [
    '../../../details-page/components/insights-section/insights-section.component.scss',
    './app-mfa-section.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppMfaSectionComponent
  extends InsightsSectionComponent
  implements OnInit
{
  constructor(_changeDetector: ChangeDetectorRef) {
    super(_changeDetector);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }
}
